const truncate = (string: string, len: number) => (len && string && string.length > len ? `${string.substring(0, len)}...` : string);
const stripTags = (str: string) => str.replace(/<\/?[^>]+(>|$)/g, '');

export { truncate, stripTags };
